import { graphql } from 'gatsby';

import LandingPage from '../../containers/landing-page';

export default LandingPage;

export const query = graphql`
  query {
    mobileImage: file(relativePath: { eq: "key-visuals/1/mobile.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    desktopImage: file(relativePath: { eq: "key-visuals/1/desktop.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
